import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2,
  FormFieldV2 as FormField,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { KhachHang, NhanVien, TaiKhoan } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const BasicInfoTab = ({ formState: { state, actions } }: BasicInfoTabProps) => {
  return (
    <div className='space-y-3 p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='startDate'
          toDateName='endDate'
          fromFieldClassName='w-[175px]'
          toFieldClassName='w-[175px]'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeFieldV2 label='Số c/từ (từ/đến)' fromName='voucherNumberStart' toName='voucherNumberEnd' />

      {/* Tài khoản nợ */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Tài khoản nợ</Label>
        <SearchField<TaiKhoan>
          name='debitAccount'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={state.taiKhoanNo?.code}
          relatedFieldValue={state.taiKhoanNo?.name}
          onRowSelection={actions.setTaiKhoanNo}
          className='w-100'
        />
      </div>

      {/* Mã khách hàng */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          name='customerCode'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          value={state.khachHang?.customer_code}
          relatedFieldValue={state.khachHang?.customer_name}
          onRowSelection={actions.setKhachHang}
          className='w-100'
        />
      </div>

      {/* Mã nhân viên */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Mã nhân viên</Label>
        <SearchField<NhanVien>
          name='employeeCode'
          searchEndpoint={`/${QUERY_KEYS.NHAN_VIEN}/`}
          searchColumns={nhanVienSearchColumns}
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          dialogTitle='Danh mục nhân viên bán hàng'
          value={state.nhanVien?.ma_nhan_vien}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien}
          onRowSelection={actions.setNhanVien}
          className='w-100'
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='description' type='text' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
